<ion-card class="chart" [ngClass]="{small: Size=='small'}">
    <ion-card-header>
        <ion-card-title style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" [title]="Data?.Title">
            {{Data?.Title || ''}}</ion-card-title>
    </ion-card-header>
    <ion-card-content [style.min-height]="Size=='small' ? '200px': '260px'">

        <ng-container [ngSwitch]="Data.IdType">
            <ng-container *ngSwitchCase="1">
                <chart-simple [data]="Data" [height]="Size=='small' ? '200' : null"></chart-simple>
            </ng-container>
            <ng-container *ngSwitchCase="2">
                <bar-chart [data]="Data" [height]="Size=='small' ? '200' : null"></bar-chart>
            </ng-container>
            <ng-container *ngSwitchCase="3">
                <line-chart [data]="Data" [height]="Size=='small' ? '200' : null"></line-chart>
            </ng-container>
            <ng-container *ngSwitchDefault>
                <chart-simple [data]="Data" [height]="Size=='small' ? '200' : null"></chart-simple>
            </ng-container>
        </ng-container>
    </ion-card-content>
</ion-card>